import { formatCount, formatNaira } from '../../../../utils/money';
import { formatUtc } from '../../../../utils/datetime';
import { DataTable, StatusPill, TableCard } from '../../../ui';

const columns = [
  { key: 'pan', header: 'PAN', className: 'whitespace-nowrap' },
  { key: 'name', header: 'Name' },
  { key: 'status', header: 'Status', render: (row) => <StatusPill status={row.status} /> },
  { key: 'volume', header: 'Volume', align: 'right', render: (row) => formatNaira(row.volume) },
  { key: 'txn_count', header: 'Transactions', align: 'right', render: (row) => formatCount(row.txn_count) },
  {
    key: 'last_transaction_at',
    header: 'Last transaction (UTC)',
    render: (row) => formatUtc(row.last_transaction_at),
  },
];

const TopIssuedUsers = ({ rows = [], loading, top, onTopChange }) => (
  <TableCard
    title="Top issued users"
    className="mb-0"
    toolbar={
      <select
        className="form-select form-select-sm w-auto"
        aria-label="Number of issued users"
        value={top}
        onChange={(event) => onTopChange(Number(event.target.value))}
      >
        {[5, 10, 25, 50].map((size) => (
          <option key={size} value={size}>
            Top {size}
          </option>
        ))}
      </select>
    }
  >
    <DataTable
      columns={columns}
      rows={rows}
      rowKey={(row) => row.pan}
      serial
      loading={loading}
      empty={{
        title: 'No issued users to rank',
        message: 'No PAN recorded a transaction in the selected period.',
      }}
    />
  </TableCard>
);

export default TopIssuedUsers;
